// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Loader = require("../../uikit/reason/atoms/Loader/Loader.bs.js");
let Sentry = require("../../reason/Sentry.bs.js");
let PageTitle = require("../../reason/common/PageTitle.bs.js");
let PageViews = require("../../reason/PageViews.bs.js");
let LoggedInAgent = require("../../reason/common/UserSession/LoggedInAgent.bs.js");
let MarkupHelpers = require("../../reason/common/MarkupHelpers/MarkupHelpers.bs.js");
let ErrorComponent = require("../../reason/common/Error/ErrorComponent.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let ReactErrorBoundary = require("react-error-boundary");
let CreateQuietSellerForm = require("./propertyForms/CreateQuietSellerForm.bs.js");

function CreateQuietSellerPage$Page(props) {
  PageViews.useRecordPageView(PageViews.Page.makeNewSellerPage());
  return JsxRuntime.jsx(MarkupHelpers.Container.make, {
    children: JsxRuntime.jsx(CreateQuietSellerForm.make, {})
  });
}

let Page = {
  Container: undefined,
  make: CreateQuietSellerPage$Page
};

function CreateQuietSellerPage$ErrorState(props) {
  return JsxRuntime.jsx(MarkupHelpers.Container.make, {
    children: JsxRuntime.jsx(ErrorComponent.make, {
      message: "We encountered an error. Please refresh or try again later..."
    })
  });
}

let ErrorState = {
  Container: undefined,
  make: CreateQuietSellerPage$ErrorState
};

function CreateQuietSellerPage$default(props) {
  return JsxRuntime.jsx(ReactErrorBoundary.ErrorBoundary, {
    FallbackComponent: _error => JsxRuntime.jsx(CreateQuietSellerPage$ErrorState, {}),
    children: JsxRuntime.jsx(React.Suspense, {
      children: JsxRuntime.jsx(JsxRuntime.Fragment, {
        children: JsxRuntime.jsx(LoggedInAgent.Provider.make, {
          loaderComponent: JsxRuntime.jsxs(JsxRuntime.Fragment, {
            children: [
              JsxRuntime.jsx(PageTitle.make, {
                title: `Loading...`
              }),
              JsxRuntime.jsx(Loader.make, {})
            ]
          }),
          children: JsxRuntime.jsx(CreateQuietSellerPage$Page, {})
        })
      }),
      fallback: JsxRuntime.jsxs(JsxRuntime.Fragment, {
        children: [
          JsxRuntime.jsx(PageTitle.make, {
            title: `Loading...`
          }),
          JsxRuntime.jsx(Loader.make, {})
        ]
      })
    }),
    onError: error => Sentry.captureException(error, "CreateQuietSellerPage.res", undefined, undefined, undefined)
  });
}

let $$default = CreateQuietSellerPage$default;

exports.Page = Page;
exports.ErrorState = ErrorState;
exports.default = $$default;
exports.__esModule = true;
/* react Not a pure module */
